import ProductDetailPageTypeConfig, { ProductDetailInfo } from "./ProductDetailPageTypeConfig";

export default new class ProductDetailInfoService {
    public getProductDetailInfo(pageTypeConfig: ProductDetailPageTypeConfig, productId: number): ProductDetailInfo {
        const productDetailInfo = pageTypeConfig.products.find((product) => product.productId === productId);

        if (productDetailInfo === undefined) {
            throw new Error(`Product with ID ${productId} not found.`);
        }

        return productDetailInfo;
    }
}();
